// Competition subpages belong to the competitions destination, never Fixtures.
export function isNavigationDestination(pathname, destination) {
  return pathname === destination || (destination === '/competitions' && /^\/competition\/[^/]+\/?$/.test(pathname));
}
